import React, { useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import LightGallery from 'lightgallery/react';
import lunch_box from '../../../../images/product/meals_box.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StatusApprove = ({ show, onClose, data, refresh }) => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;

    const onInit = () => {
    };

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const holdDetails = JSON.parse(data.hold_details);

    // Get dates array from the last object in holdDetails
    const lastDates = holdDetails[holdDetails.length - 1].date;
    
    const lastreason = holdDetails[holdDetails.length - 1].reason;

    const [reason, setreason] = useState('');

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        
        if (!reason) {
            newErrors.reason = "This Field is Required.";
        }

        return newErrors;
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { reason };
        axios.post(`${baseURL}/subscription/approve_hold/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Hold Approved Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Hold Approve Failed");
            });
    };


    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Approve</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                            <label className='text-primary fs-7 font-w400'>{data.lead_mobile_no}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Product</label>
                            <div className="d-flex align-items-center justify-content-start gap-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : lunch_box} className='border rounded px-1 py-0'>
                                        <img src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : lunch_box} alt={data.product_name} className='cursor-pointer w-45px h-45px' />
                                    </div>
                                </LightGallery>
                                <div className='mb-0'>
                                    <label className='text-black fs-6 font-w500'>{data.product_name}</label>
                                    <div className="d-block">
                                        <div className="text-primary fs-7 font-w400">{data.timeline_name} ({data.timeline_days} Days)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className="text-gray-800 font-w500 fs-7">Duration Start Date</label>
                             <label className=' fs-6 font-w500 text-primary'>{formatDate(data.start_date)}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className="text-gray-800 font-w500 fs-7">Duration End Date</label>
                            <label className=' fs-6 font-w500 text-danger'>{formatDate(data.end_date)}</label>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-12">
                            <label className="text-gray-800 font-w500 fs-7 mb-1">Hold Dates</label>
                            <div>
                                {lastDates.map((date, idx) => (
                                    <React.Fragment key={idx}>
                                        <label className="text-info fw-bold fs-7" style={{ minWidth: 'fit-content' }}>
                                            {formatDate(date)}
                                        </label>
                                        {idx < lastDates.length - 1 && <span className='text-info'>,&nbsp;</span>}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-2'>
                            <label className="text-gray-800 font-w500 fs-7">Reason</label>
                            <label className=' fs-6 font-w500 text-black'>{lastreason}</label>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-2'>
                            <label className="text-gray-800 font-w500 fs-7">Verify Reason<span className='text-danger'>*</span></label>
                            <textarea className="form-control h-auto" row={'2'} placeholder="Enter Reason.." 
                                value={reason}
                                onChange={(e)=> setreason(e.target.value)}
                            />
                            {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                        </div>
                    </div>
                    
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        
                        <Link className="btn btn-sm btn-primary" onClick={handleSubmit}>Approve<i className='fas fa-angle-double-right ms-2'></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default StatusApprove;
